// 引用API文件
import api from './api.js'
import C from './C.js'

///api的uri
const API_LIST = {
  getFunctionList_url:"appFunction/getFunctionList",//获取功能列表
  addFunctionMore_url:"appFunction/addFunctionMore",///提交功能
  setFunctionFavor_url:"appFunction/setFunctionFavor",//点赞
  getFunctionInfo_url:"appFunction/getFunctionInfo",///获取功能信息
  getFaqList_url:"faq/getFaqList",//获取 faq 列表
  getResultByCommand_url:"https://daoshuback.hatlab.cn/daoshu111/activity/getResultByCommand",///获取功能信息
  uploadImage: 'https://upload.qiniup.com'
}

///获取基础参数
var getParam = function () {
  var param = C.getParam();
  return param;
}

///带有promise请求接口数据
function promiseRequest(param,systemParam,url){
  return new Promise((resolve, reject) => {
    api.get(param,systemParam, url,function (result) {
      //result已经是最终的数据状态了
      resolve(result)
    })
  });
}

// 图片上传
function uploadPromiseRequest(param, url){
  return new Promise((resolve, reject) => {
    api.uploadImg(url, param,function (result) {
      //result已经是最终的数据状态了
      resolve(result)
    })
  })
}

////网络接口请求
const NetGo = {
  getFunctionList:function () {///获取文件列表
    var url = API_LIST.getFunctionList_url
    var param = getParam()

    ///获取系统信息
    var systemParam =  C.getSystemInfo()

    // alert(JSON.stringify(param))
    // alert(JSON.stringify(systemParam))

    return promiseRequest(param,systemParam, url);
  },
  addFunctionMore:function (functionName, imgList) {///提交功能
    var url = API_LIST.addFunctionMore_url
    var param = getParam()
    ///功能名称
    param.functionName = functionName
    param.imgList = imgList
    ///获取系统信息
    var systemParam =  C.getSystemInfo()

    return promiseRequest(param,systemParam, url);
  },
  setFunctionFavor:function (functionId,isFavor) {///点赞
    var url = API_LIST.setFunctionFavor_url
    var param = getParam()
    ///功能名称
    param.functionId = functionId
    //点赞(1)或者取消点赞(0)
    param.isFavor = isFavor

    ///获取系统信息
    var systemParam =  C.getSystemInfo()

    return promiseRequest(param,systemParam, url);
  },
  getFunctionInfo:function (id) {///获取功能信息
    var url = API_LIST.getFunctionInfo_url
    var param = getParam()
    ///功能id
    param.id = id

    ///获取系统信息
    var systemParam =  C.getSystemInfo()

    return promiseRequest(param,systemParam, url);
  },
  getResultByCommand:function (commandCode) {///获取口令对应的信息
    var url = API_LIST.getResultByCommand_url
    var param = getParam()
    //命令
    param.commandCode = commandCode

    ///获取系统信息
    var systemParam =  C.getSystemInfo()
    return promiseRequest(param,systemParam, url);
  },
  getFaqList:function () {///获取 faq列表
    var url = API_LIST.getFaqList_url
    var param = getParam()

    ///获取系统信息
    var systemParam =  C.getSystemInfo()

    // alert(JSON.stringify(param))
    // alert(JSON.stringify(systemParam))

    return promiseRequest(param,systemParam, url);
  },
  uploadImage:function (param) {
    var url = API_LIST.uploadImage

    return uploadPromiseRequest(param, url)
  }
};

//暴露出去的接口
export default {
  getFunctionList:NetGo.getFunctionList,///获取功能列表
  addFunctionMore: NetGo.addFunctionMore,///提交功能
  setFunctionFavor: NetGo.setFunctionFavor,//设置点赞
  getFunctionInfo: NetGo.getFunctionInfo,//获取功能信息

  getFaqList: NetGo.getFaqList,//获取 faq 列表

  getResultByCommand: NetGo.getResultByCommand,//口令
  addUploadImage: NetGo.uploadImage // 上传图片
}



// WEBPACK FOOTER //
// ./src/utils/NetGo.js